// src/pages/NotFoundPage.tsx
import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";
import { t } from "../i18n";

const NotFoundPage: React.FC = () => {
  return (
    <div className="notfound-container">
      <div className="notfound-box">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-message">{t("notFoundPage.pageNotFound")}</p>
        <Link to="/" className="notfound-button">
          {t("notFoundPage.goToHome")}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
